/// <reference lib="dom" preserve="true" />
/// <reference types="jquery" preserve="true" />
import { Device } from "@siteimprove/alfa-device";
import { Document, Node } from "@siteimprove/alfa-dom";
import { Request, Response } from "@siteimprove/alfa-http";
import { Page } from "@siteimprove/alfa-web";
import * as device from "@siteimprove/alfa-device/native";
import * as dom from "@siteimprove/alfa-dom/native";
/**
 * @public
 */
export var JQuery;
(function (JQuery) {
    async function toPage(value) {
        const nodeJSON = await dom.Native.fromNode(value.get(0));
        const deviceJSON = device.Native.fromWindow(window);
        const pageDevice = Device.from(deviceJSON);
        return Page.of(Request.empty(), Response.empty(), Document.of([Node.from(nodeJSON, pageDevice)]), pageDevice);
    }
    JQuery.toPage = toPage;
})(JQuery || (JQuery = {}));
//# sourceMappingURL=jquery.js.map